import { IFilters } from '@/interfaces/storageTracking/IFilters.ts';
import { useFilterDataStore } from '@/stores/storageTracking/FilterDataStore.ts';

export function getAdditionalCsvExport (title?: string, filters?: IFilters, suffix?: string): Array<Array<string | number | undefined>> {
    const filterDataStore = useFilterDataStore();

    const data: Array<Array<string | number | undefined>> = [];

    data.push(['Title', title]);

    data.push(['Units', suffix]);

    if (filters) {
        const segmentsRow = ['Segments'];
        if (filters.segments.length === 0) {
            segmentsRow.push('All segments');
        } else {
            filters.segments.forEach(segment => {
                segmentsRow.push(segment === 'AA' ? 'All segments' : segment);
            });
        }

        data.push(segmentsRow);

        const installationsRow = ['Installations'];
        if (filters.installations.length === 0) {
            installationsRow.push('All installations');
        } else {
            filters.installations.forEach(installation => {
                installationsRow.push(installation === 'AA' ? 'All installation' : installation);
            });
        }
        data.push(installationsRow);

        const techsRow = ['Technologies'];
        filters.technologies.forEach(tech => {
            techsRow.push(tech === 'AA' ? 'All technologies' : tech);
        });
        data.push(techsRow);

        const countriesRow = ['Countries'];
        if (filters.countries.length === 1 && filters.countries[0] === 'AA') {
            countriesRow.push('All countries');
        } else {
            filters.countries.forEach(country => {
                const countryName = filterDataStore.countryNameById[country];
                countriesRow.push(countryName ?? '');
            });
        }
        data.push(countriesRow);

        const operationalRow = ['Operational Status'];
        if (filters.operational.includes('Operational')) {
            operationalRow.push('Operational projects');
        } else {
            operationalRow.push('All Projects');
        }
        data.push(operationalRow);

        data.push(['Include pumped storage', filters.pumpedStorage.toString().toLowerCase()]);

        const actualFilter = filterDataStore.projectTypeOptions.find(option => option.id === filters.actual.toString());
        data.push(['Actual projects vs Overall forecast', actualFilter?.name]);

        if (filters.cumulative !== null) {
            if (filters.cumulative) data.push(['Cumulative vs Additions', 'Cumulative']);
            else data.push(['Cumulative vs Additions', 'Additions']);
        }
    }

    return data;
}
